function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardCapitalone = function SvgCardCapitalone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 40,
    height: 26,
    rx: 4,
    ry: 4,
    style: {
      fill: "#022247"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.295.295 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582Zm3.53-.768c0-.163.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569Zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98Zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569Zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .163.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98Z",
    style: {
      fill: "#003c73",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.89 10.094a35.195 35.195 0 0 1 3.166-.082c.753.025 1.509.073 2.248.224.417.091.839.207 1.203.433.218.139.432.334.478.598.057.306-.07.607-.227.865-.291.464-.689.851-1.097 1.216-.514.45-1.062.862-1.624 1.252-.551.378-1.104.753-1.666 1.115-.716.453-1.448.881-2.194 1.285h-1.013a17.792 17.792 0 0 0 1.481-1.157 42.099 42.099 0 0 0 1.716-1.554c.109-.103.226-.2.309-.327.266-.367.511-.79.499-1.256-.007-.318-.183-.611-.423-.815-.393-.333-.896-.503-1.389-.631a11.008 11.008 0 0 0-1.521-.248c-.279-.015-.557-.054-.837-.055v-.792c.296-.035.593-.048.89-.07Z",
    style: {
      fill: "#cc2427"
    }
  }));
};
export default SvgCardCapitalone;